import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment"
import moment from "moment/moment";
export const DatePickerComponent = props => {
  const [date, setDate] = useState(null);
  useEffect(() => {
    if (props.date){
      setDate(moment(props.date, 'MM/DD/YYYY'));
    }
  }, [props.date]);

  const handleDateSelection = (pickedDate) => {
    if (pickedDate) {
      setDate(pickedDate);
      props.onDateChange(pickedDate.format("MM/DD/YYYY"));
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        value={date}
        onChange={handleDateSelection}
        format='MM/DD/YYYY'
        slotsProps={{
          TextField: {
            placeholder : "MM/DD/YYYY",
            required:true,
            fullWidth:true
          }
        }}
      />

    </LocalizationProvider>
  );
};
